/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Settings_Google_ConnectedInputs */

const en_settings_google_connected = /** @type {(inputs: Settings_Google_ConnectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Connected as ${i?.email}`)
};

const he_settings_google_connected = /** @type {(inputs: Settings_Google_ConnectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`מחובר כ-${i?.email}`)
};

/**
* | output |
* | --- |
* | "Connected as {email}" |
*
* @param {Settings_Google_ConnectedInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_google_connected = /** @type {((inputs: Settings_Google_ConnectedInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Google_ConnectedInputs, { locale?: "en" | "he" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_google_connected(inputs)
	return he_settings_google_connected(inputs)
});